import { useDispatch } from 'react-redux';

import { removeCookie } from '@/redux/modules/cookies';
import { trackLoggedOutEvent } from '@/services/analytics/accounts';
import { setMixpanelFlagUser } from '@/services/experiments/mixpanel';
import { resetSegmentUser } from '@/services/segment';
import { removeItemFromLocalStorage } from '@/utility/localstorage';
import { logger } from '@/utility/logger';
import {
  COOKIE_SESSION_NAME,
  EVENT_AUTHENTICATE_NAME,
  EVENT_NAME_LOGOUT,
  resetSessionCookie,
} from '@/utility/session';

export function useUser() {
  const dispatch = useDispatch();

  const logoutUser = async () => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const event = new CustomEvent(EVENT_AUTHENTICATE_NAME, {
        cancelable: true,
        bubbles: true,
        detail: {
          name: EVENT_NAME_LOGOUT,
        },
      });

      // the user calling event.preventDefault will cause this dispatch to return false
      const header = document.getElementById('global-header');
      if (header) header.dispatchEvent(event);

      resetSessionCookie();
      dispatch(removeCookie(COOKIE_SESSION_NAME));
      removeItemFromLocalStorage('sessionRecentSearchesWithFilters');
      trackLoggedOutEvent();

      // Run in anonymous async fn to not block callers awaiting on this function.
      (async () => {
        const anonId = await resetSegmentUser();
        if (anonId) {
          setMixpanelFlagUser(anonId);
        }
      })();
    } catch (exception) {
      logger.error(exception);
    }
  };

  return { logout: logoutUser };
}
